import { Icon, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { sdkIcons } from '../../../graphics/UrlEndpoints'
import { sdkMappings } from '../Support/Documentation/APIandSDKs'

interface SDKIntegrationGridProps {
  columns?: number
  gap?: number
  sdkKeys?: string[]
  fontSize?: string
  iconSize?: string | number
}

const SDKIntegrationGrid = ({
  columns = 4,
  gap = 4,
  sdkKeys,
  fontSize = '12px',
  iconSize = '32px',
}: SDKIntegrationGridProps): React.ReactElement => {
  const keys = sdkKeys || Object.keys(sdkMappings)

  return (
    <SimpleGrid columns={columns} gap={gap}>
      {keys.map(key => {
        const obj = sdkMappings[key]
        const IconComponent = sdkIcons[key]
        
        if (!obj || !IconComponent) return null

        return (
          <Link
            _hover={{ textDecoration: 'none', outline: 'none' }}
            color="currentcolor"
            key={obj.title}
            href={obj.link}
            isExternal
          >
            <VStack spacing={2}>
              <Icon as={IconComponent} boxSize={iconSize} />
              <Text color="appBattleshipGrey" fontSize={fontSize} fontWeight="400">
                {obj.title}
              </Text>
            </VStack>
          </Link>
        )
      })}
    </SimpleGrid>
  )
}

export default SDKIntegrationGrid
